/**
 * VR Bundle Selector — JavaScript
 * Selettore bundle personalizzato Kylea — Adattato per tema Focal (Maestrooo) 8.x
 *
 * v2 — Integrazione cart NATIVA Focal:
 *  - L'ATC NON usa più il metodo privato cartDrawer._rerenderCart().
 *  - Dopo /cart/add.js emette gli eventi nativi del tema:
 *      • "variant:added"  → Focal apre drawer / cart-notification
 *      • "cart:refresh"   → Focal ri-renderizza drawer, contatore, barra spedizione
 *    (entrambi bubbling, intercettati dal rootDelegate su <html>)
 *  - Rimosso il DOM-moving (moveToProductColumn): ora il selector è un BLOCK
 *    renderizzato nativamente dentro main-product, quindi niente duplicati nel
 *    customizer e niente spostamenti fragili.
 */

(function () {
  'use strict';

  // --- State ---
  let bundleConfig = {
    type: 'single',
    totalQty: 1,
    paidQty: 1,
    pricePerUnit: 0,
    comparePerUnit: 0,
  };

  // [{color, size, qty, variantId, imageUrl}]
  let selectedItems = [];

  // --- Eventi nativi Focal ---
  // Il cart-drawer/notification di Focal ascolta sul rootDelegate (<html>):
  //   rootDelegate.on("cart:refresh", _rerenderCart)
  //   .on("variant:added", () => this.open = true)
  // Dispatchiamo eventi DOM bubbling: risalgono fino a <html> e attivano il tema.
  function emitNative(eventName, detail, sourceEl) {
    const target = sourceEl || document.documentElement;
    target.dispatchEvent(new CustomEvent(eventName, {
      bubbles: true,
      cancelable: true,
      detail: detail || {},
    }));
  }

  // --- Init ---
  function init() {
    const container = document.querySelector('.vr-bundle-container');
    if (!container) return;

    const firstRadio = container.querySelector('.vr-quantity-radio:checked')
      || container.querySelector('.vr-quantity-radio');
    if (firstRadio) {
      firstRadio.checked = true;
      applyBundleType(firstRadio);
    }

    bindEvents(container);
    bindSizeGuide(container);
    updateScrollIndicator(container);
    updateItemsRemaining(container);
    updateBuyButton(container);
    updateProgressBar(container);
    updateAddButtons(container);
    updatePriceDisplay(container);

    // Le thumbnail caricano in lazy → ricalcola la scrollbar quando cambia l'altezza
    window.addEventListener('load', () => { updateScrollIndicator(container); updateProgressBar(container); });
    setTimeout(() => { updateScrollIndicator(container); updateProgressBar(container); }, 500);
  }

  // --- Guida alle taglie: banner largo che apre un modal custom ---
  function bindSizeGuide(container) {
    var banner = container.querySelector('.vr-size-guide-banner');
    var modal = container.querySelector('.vr-size-guide-modal');
    if (!banner || !modal) return;
    if (banner.dataset.vrSgBound === '1') return;
    banner.dataset.vrSgBound = '1';

    function open() {
      modal.hidden = false;
      document.documentElement.style.overflow = 'hidden';
    }
    function close() {
      modal.hidden = true;
      document.documentElement.style.overflow = '';
    }

    banner.addEventListener('click', open);
    modal.addEventListener('click', function (e) {
      if (e.target.closest('[data-vr-sg-close]')) close();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !modal.hidden) close();
    });
  }

  // --- Event bindings ---
  function bindEvents(container) {
    if (container.dataset.vrBound === '1') return; // evita doppi listener (customizer)
    container.dataset.vrBound = '1';

    // Quantity radio buttons
    container.querySelectorAll('.vr-quantity-radio').forEach(radio => {
      radio.addEventListener('change', () => {
        applyBundleType(radio);
        updateProgressBar(container);
        updateItemsRemaining(container);
        updateBuyButton(container);
        updatePriceDisplay(container);
      });
    });

    // AGGIUNGI -> aggiunge la taglia selezionata (multi-taglia per colore)
    container.querySelectorAll('.vr-add-variant-btn').forEach(btn => {
      btn.addEventListener('click', () => {
        const item = btn.closest('.vr-variant-item');
        if (item) addSize(item, container);
      });
    });

    // +/- -> agiscono sulla taglia attualmente nel dropdown del colore
    container.querySelectorAll('.vr-quantity-btn').forEach(btn => {
      btn.addEventListener('click', () => {
        const item = btn.closest('.vr-variant-item');
        if (!item) return;
        if (btn.dataset.action === 'plus') addSize(item, container);
        else removeSize(item, container, null);
      });
    });

    // Rimozione di una chip taglia (delegation per ogni card)
    container.querySelectorAll('.vr-variant-item').forEach(item => {
      const chips = item.querySelector('.vr-selected-chips');
      if (!chips) return;
      chips.addEventListener('click', (e) => {
        const rm = e.target.closest('.vr-chip-remove');
        if (!rm) return;
        const chip = rm.closest('.vr-size-chip');
        if (chip) removeSize(item, container, chip.dataset.size);
      });
    });

    // Buy now button
    const buyBtn = container.querySelector('.vr-buy-now-btn');
    if (buyBtn) {
      buyBtn.addEventListener('click', () => handleBuyNow(container));
    }

    // Upsell add button
    container.querySelectorAll('.vr-upsell-add-btn').forEach(btn => {
      btn.addEventListener('click', () => handleUpsellAdd(btn));
    });

    // Scroll indicator
    const variantsList = container.querySelector('.vr-variants-list');
    if (variantsList) {
      variantsList.addEventListener('scroll', () => { updateScrollIndicator(container); updateProgressBar(container); });
    }
  }

  // --- Bundle type ---
  function applyBundleType(radio) {
    bundleConfig.type = radio.value;
    bundleConfig.totalQty = parseInt(radio.dataset.quantity) || 1;
    bundleConfig.paidQty = parseInt(radio.dataset.paid) || 1;

    const optionDiv = radio.nextElementSibling;
    if (optionDiv) {
      bundleConfig.pricePerUnit = parseFloat(optionDiv.dataset.price || '0');
      bundleConfig.comparePerUnit = parseFloat(optionDiv.dataset.comparePrice || '0');
    }

    selectedItems = [];
    document.querySelectorAll('.vr-quantity-value').forEach(el => el.textContent = '0');
    document.querySelectorAll('.vr-selected-chips').forEach(el => el.innerHTML = '');
    document.querySelectorAll('.vr-variant-item').forEach(el => el.classList.remove('added'));
    const cont = document.querySelector('.vr-bundle-container');
    if (cont) updateAddButtons(cont);
  }

  // --- Selezione multi-taglia per colore ---
  function readSel(item) {
    const color = item.dataset.color;
    const sizeSelect = item.querySelector('.vr-variant-size-select');
    const size = sizeSelect ? sizeSelect.value : '';
    const selOpt = (sizeSelect && sizeSelect.selectedOptions) ? sizeSelect.selectedOptions[0] : null;
    const variantId = selOpt ? selOpt.dataset.variantId : (sizeSelect ? sizeSelect.dataset.variantId : item.dataset.variantId);
    const price = parseInt((selOpt ? selOpt.dataset.price : (sizeSelect ? sizeSelect.dataset.price : '0')) || '0');
    const compare = parseInt((selOpt ? selOpt.dataset.compare : (sizeSelect ? sizeSelect.dataset.compare : '0')) || '0') || price;
    return { color, size, variantId, price, compare, sizeSelect };
  }

  function getColorQty(color) {
    return selectedItems.filter(i => i.color === color).reduce((s, i) => s + i.qty, 0);
  }

  // AGGIUNGI / + : aggiunge 1 della taglia nel dropdown, se c'e' spazio nel bundle
  function addSize(item, container) {
    const sel = readSel(item);
    if (!sel.size || !sel.variantId) {
      if (sel.sizeSelect) {
        sel.sizeSelect.style.borderColor = '#FED23A';
        setTimeout(() => sel.sizeSelect.style.borderColor = '', 1000);
      }
      return;
    }
    if (getTotalSelected() >= bundleConfig.totalQty) return; // cap raggiunto
    const existing = selectedItems.find(i => i.color === sel.color && i.size === sel.size);
    if (existing) existing.qty += 1;
    else selectedItems.push({ color: sel.color, size: sel.size, qty: 1, variantId: sel.variantId, price: sel.price, compare: sel.compare });
    item.classList.add('added');
    afterSelectionChange(item, container);
  }

  // - : toglie 1 della taglia nel dropdown (o dall'ultima chip del colore).
  // size != null (chip x) -> rimuove l'intera riga di quella taglia.
  function removeSize(item, container, size) {
    const color = item.dataset.color;
    if (size) {
      selectedItems = selectedItems.filter(i => !(i.color === color && i.size === size));
    } else {
      const cur = readSel(item).size;
      let it = selectedItems.find(i => i.color === color && i.size === cur);
      if (!it) {
        const arr = selectedItems.filter(i => i.color === color);
        it = arr[arr.length - 1];
      }
      if (it) {
        it.qty -= 1;
        if (it.qty <= 0) selectedItems = selectedItems.filter(i => i !== it);
      }
    }
    if (getColorQty(color) === 0) item.classList.remove('added');
    afterSelectionChange(item, container);
  }

  function afterSelectionChange(item, container) {
    renderChips(item);
    updateColorControl(item);
    updateItemsRemaining(container);
    updateProgressBar(container);
    updateBuyButton(container);
    updateAddButtons(container);
    updatePriceDisplay(container);
  }

  function renderChips(item) {
    const wrap = item.querySelector('.vr-selected-chips');
    if (!wrap) return;
    const color = item.dataset.color;
    wrap.innerHTML = selectedItems.filter(i => i.color === color).map(i =>
      '<span class="vr-size-chip" data-size="' + i.size + '">' + i.size +
      ' <span class="vr-chip-qty">&times;' + i.qty + '</span>' +
      '<button type="button" class="vr-chip-remove" aria-label="Rimuovi">&times;</button></span>'
    ).join('');
  }

  function updateColorControl(item) {
    const valueEl = item.querySelector('.vr-quantity-value');
    if (valueEl) valueEl.textContent = getColorQty(item.dataset.color);
  }

  // Cap raggiunto -> i bottoni AGGIUNGI (colori non ancora scelti) diventano grigi/disabilitati
  function updateAddButtons(container) {
    const capped = getTotalSelected() >= bundleConfig.totalQty;
    container.querySelectorAll('.vr-add-variant-btn').forEach(b => {
      b.disabled = capped;
      b.classList.toggle('vr-disabled', capped);
    });
  }

  // --- Items remaining ---
  function getTotalSelected() {
    return selectedItems.reduce((sum, i) => sum + i.qty, 0);
  }

  function updateItemsRemaining(container) {
    const el = container.querySelector('.vr-items-remaining');
    if (!el) return;
    const remaining = bundleConfig.totalQty - getTotalSelected();
    const prefix = el.dataset.suffix || 'Scegli ancora';
    el.textContent = remaining > 0 ? `${prefix} ${remaining}` : '✓ Completo';
  }

  // --- Progress bar ---
  // Scrollbar verticale custom: il pollice riflette la posizione
  // e la porzione visibile della lista colori scrollabile.
  function updateProgressBar(container) {
    const list = container.querySelector('.vr-variants-list');
    const track = container.querySelector('.vr-progress-bar-container');
    const thumb = container.querySelector('.vr-progress-bar');
    if (!list || !track || !thumb) return;

    const trackH = list.clientHeight;
    const ratio = list.scrollHeight > 0 ? list.clientHeight / list.scrollHeight : 1;

    if (ratio >= 1) { track.style.display = 'none'; return; } // niente scroll → niente barra
    track.style.display = 'block';

    const thumbH = Math.max(24, Math.round(ratio * trackH));
    const maxTop = trackH - thumbH;
    const denom = list.scrollHeight - list.clientHeight;
    const scrollRatio = denom > 0 ? list.scrollTop / denom : 0;

    thumb.style.height = thumbH + 'px';
    thumb.style.top = Math.round(scrollRatio * maxTop) + 'px';
  }

  // --- Buy button state ---
  function updateBuyButton(container) {
    const btn = container.querySelector('.vr-buy-now-btn');
    if (!btn) return;
    const textEl = btn.querySelector('.vr-buy-now-btn-text');
    const isReady = getTotalSelected() >= bundleConfig.totalQty;

    btn.disabled = false;
    btn.classList.toggle('vr-is-ready', isReady);
    if (textEl) {
      textEl.textContent = isReady
        ? (btn.dataset.textBuy || 'Acquista ora')
        : (btn.dataset.textSelect || 'Seleziona Colori');
    }
  }

  // --- Prezzo dinamico ---
  // Formatta centesimi -> "59,98€" (formato store Kylea)
  function fmtMoney(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + '€';
  }

  // Calcola il totale reale dai colori/taglie SELEZIONATI applicando lo sconto
  // "compra X, ricevi Y gratis": gli Y paia più economici sono gratis
  // (replica lo sconto automatico "Compra X ottieni Y" di Shopify).
  function computeDynamicPrice() {
    const unitPrices = [];
    const unitCompares = [];
    selectedItems.forEach(it => {
      for (let k = 0; k < it.qty; k++) {
        unitPrices.push(it.price || 0);
        unitCompares.push(it.compare || it.price || 0);
      }
    });
    // Lo sconto "Compra X, ricevi Y" sblocca i paia gratis SOLO dopo aver
    // raggiunto i paia paganti (come lo sconto automatico Shopify): finché
    // selezioni meno di paidQty non c'e' nessun gratis (niente 0,00€ prematuro).
    const selectedCount = unitPrices.length;
    const freeCount = Math.min(
      Math.max(0, selectedCount - bundleConfig.paidQty),
      Math.max(0, bundleConfig.totalQty - bundleConfig.paidQty)
    );
    const sortedAsc = unitPrices.slice().sort((a, b) => a - b);
    let freeSum = 0;
    for (let k = 0; k < Math.min(freeCount, sortedAsc.length); k++) freeSum += sortedAsc[k];
    const finalCents = unitPrices.reduce((a, b) => a + b, 0) - freeSum;
    const compareCents = unitCompares.reduce((a, b) => a + b, 0);
    return { finalCents, compareCents };
  }

  // --- Price display ---
  function updatePriceDisplay(container) {
    const comparePriceEl = container.querySelector('.vr-compare-price');
    const finalPriceEl = container.querySelector('.vr-final-price');
    if (!comparePriceEl || !finalPriceEl) return;

    // Se l'utente ha selezionato dei colori → prezzo DINAMICO sui prezzi reali
    if (selectedItems.length > 0) {
      const d = computeDynamicPrice();
      finalPriceEl.textContent = fmtMoney(d.finalCents);
      comparePriceEl.textContent = fmtMoney(d.compareCents);
      comparePriceEl.style.display = d.compareCents > d.finalCents ? '' : 'none';
      return;
    }

    // Nessuna selezione → stima del tier (prezzo di default, indicativa)
    const radio = container.querySelector('.vr-quantity-radio:checked');
    if (!radio) return;

    const compareRaw = radio.dataset.compareTotal;
    const finalRaw = radio.dataset.finalTotal;

    if (compareRaw) comparePriceEl.textContent = compareRaw;
    if (finalRaw) finalPriceEl.textContent = finalRaw;

    comparePriceEl.style.display = compareRaw && compareRaw !== finalRaw ? '' : 'none';
  }

  // --- Buy now / add to cart (NATIVO Focal) ---
  async function handleBuyNow(container) {
    if (getTotalSelected() < bundleConfig.totalQty) {
      const step2 = container.querySelectorAll('.vr-step')[1];
      if (step2) {
        step2.style.outline = '2px solid #FED23A';
        setTimeout(() => step2.style.outline = '', 1500);
      }
      return;
    }

    const btn = container.querySelector('.vr-buy-now-btn');
    const textEl = btn?.querySelector('.vr-buy-now-btn-text');
    const prevText = textEl ? textEl.textContent : '';
    if (btn) btn.disabled = true;
    if (textEl) textEl.textContent = 'Aggiunta in corso...';

    // Build line items
    const items = selectedItems.map(item => ({
      id: parseInt(item.variantId),
      quantity: item.qty,
      properties: { _bundle_type: bundleConfig.type },
    }));

    // Add upsell if toggled
    const upsellBtn = container.querySelector('.vr-upsell-add-btn.added');
    if (upsellBtn) {
      const upsellVariantId = upsellBtn.closest('.vr-upsell-item')?.dataset.variantId;
      if (upsellVariantId) items.push({ id: parseInt(upsellVariantId), quantity: 1 });
    }

    try {
      // Richiediamo anche l'HTML della sezione mini-cart: così il drawer si
      // ri-renderizza in modo SINCRONO (niente race → niente drawer vuoto).
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: JSON.stringify({ items, sections: ['mini-cart'], sections_url: window.location.pathname }),
      });
      if (!response.ok) throw new Error('Cart add failed: ' + response.status);
      const addData = await response.json();

      // Carrello completo (per item_count / contatori)
      let cartData = null;
      try {
        const cartResp = await fetch('/cart.js', { cache: 'no-store' });
        cartData = await cartResp.json();
      } catch (e) {}

      // detail.cart con .sections["mini-cart"] → _rerenderCart usa direttamente l'HTML
      const cartDetail = Object.assign({}, cartData || {}, {
        sections: (addData && addData.sections) || (cartData && cartData.sections),
      });

      // -- Eventi NATIVI Focal (stessa sequenza del product-form nativo) ---
      // 1) variant:added → notifica componenti (analytics, ecc.)
      emitNative('variant:added', { items, cart: cartDetail }, btn || container);
      // 2) cart:updated → aggiorna contatore carrello, barra spedizione gratuita
      emitNative('cart:updated', { cart: cartDetail }, document.documentElement);
      // 3) cart:refresh con openMiniCart:true → ri-renderizza E apre il mini-cart drawer
      emitNative('cart:refresh', { cart: cartDetail, openMiniCart: true }, document.documentElement);

      // Reset selezioni
      selectedItems = [];
      updateItemsRemaining(container);
      updateProgressBar(container);
      container.querySelectorAll('.vr-variant-item').forEach(el => el.classList.remove('added'));
      container.querySelectorAll('.vr-selected-chips').forEach(el => el.innerHTML = '');
      container.querySelectorAll('.vr-quantity-value').forEach(el => el.textContent = '0');
      updateAddButtons(container);

    } catch (err) {
      console.error('[VR Bundle] Cart error:', err);
      if (textEl) textEl.textContent = prevText;
      alert(window.VR_ENGRAVING_TEXTS?.cart_error_message || 'Si è verificato un errore. Per favore riprova.');
    } finally {
      if (btn) btn.disabled = false;
      updateBuyButton(container);
    }
  }

  // --- Upsell add (NATIVO Focal) ---
  async function handleUpsellAdd(btn) {
    if (btn.classList.contains('added')) return;

    const item = btn.closest('.vr-upsell-item');
    const variantId = item?.dataset.variantId;
    if (!variantId) return;

    btn.disabled = true;
    const originalText = btn.textContent;
    btn.textContent = window.VR_UPSELL_TEXTS?.button_adding || 'Aggiunta...';

    try {
      const resp = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: JSON.stringify({ items: [{ id: parseInt(variantId), quantity: 1 }], sections: ['mini-cart'], sections_url: window.location.pathname }),
      });
      if (!resp.ok) throw new Error('Upsell add failed');
      const addData = await resp.json();

      let cartData = null;
      try { cartData = await (await fetch('/cart.js', { cache: 'no-store' })).json(); } catch (e) {}

      const cartDetail = Object.assign({}, cartData || {}, {
        sections: (addData && addData.sections) || (cartData && cartData.sections),
      });

      btn.textContent = window.VR_UPSELL_TEXTS?.button_added || 'Aggiunto ✓';
      btn.classList.add('added');

      // Eventi nativi: aggiorna + apre + ri-renderizza il drawer
      emitNative('variant:added', { items: [{ id: parseInt(variantId), quantity: 1 }], cart: cartDetail }, btn);
      emitNative('cart:updated', { cart: cartDetail }, document.documentElement);
      emitNative('cart:refresh', { cart: cartDetail, openMiniCart: true }, document.documentElement);

    } catch (err) {
      console.error('[VR Bundle] Upsell error:', err);
      btn.textContent = originalText;
    } finally {
      btn.disabled = false;
    }
  }

  // --- Scroll indicator ---
  function updateScrollIndicator(container) {
    const list = container.querySelector('.vr-variants-list');
    const indicator = container.querySelector('.vr-scroll-indicator');
    if (!list || !indicator) return;

    const isScrollable = list.scrollHeight > list.clientHeight + 10;
    const isAtBottom = list.scrollTop + list.clientHeight >= list.scrollHeight - 10;

    indicator.classList.toggle('visible', isScrollable && !isAtBottom);
  }

  // --- Boot ---
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Shopify customizer: re-init quando la section/block viene ri-renderizzato
  document.addEventListener('shopify:section:load', function (e) {
    if (!e.target) return;
    const isOurs = e.target.classList?.contains('section-vr-bundle')
      || !!e.target.querySelector?.('.vr-bundle-container');
    if (isOurs) setTimeout(init, 50);
  });
  document.addEventListener('shopify:block:select', function (e) {
    if (e.target && e.target.querySelector?.('.vr-bundle-container')) setTimeout(init, 50);
  });

})();
